export type Handler = (args?: any) => void | Promise<any>
type Registry = { [event: string]: Set<Handler>}
export type PubSub = {
  subscribe: (event: string, handler: Handler) => () => boolean
  unsubscribe: (event: string, handler: Handler) => boolean
  publish: (event: string, args?: any) => void
  query: (args?: any) => Handler[]
  clear: () => void
}
export const getPubSub = (): PubSub => {
  let registry = {} as Registry


  function subscribe(event: string, handler: Handler) {
    registry[event] = registry[event] || new Set()
    registry[event].add(handler)
    return () => unsubscribe(event, handler)
  }

  function unsubscribe(event: string, handler: Handler) {
    return registry[event].delete(handler)
  }

  function publish(event: string, args?: any) {
    event && registry[event] && registry[event].forEach((handler) => {
      handler(args)
    })
  }

  function query(event: string) {
    return registry[event] && Array.from(registry[event])|| []
  }

  function clear() {
    registry = {}
  }

  return {
    subscribe,
    unsubscribe,
    publish,
    query,
    clear,
  }
}
